// const api = 'http://localhost:3005'
const api = 'http://xn--lheaveninn-b7a.com'

export default api;